/** Einzeilige Übersetzungs-Vorschau unter einem editierbaren Feld (Eingabe zeigt immer das Original). */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../lib/theme';
import { resolveTranslation, type FieldTranslations } from '../../lib/contentTranslations';
import { TranslationBadge, TranslationPopover } from './TranslationPopover';
import type { TranslationTarget } from './TranslatedText';

export function TranslationHint({ dark, original, entries, target }: {
  dark: boolean; original: string | null | undefined; entries: FieldTranslations | undefined; target: TranslationTarget;
}) {
  const t = getThemeColors(dark);
  const { i18n } = useTranslation();
  const [local, setLocal] = useState(entries);
  const [seen, setSeen] = useState(entries);
  if (seen !== entries) { setSeen(entries); setLocal(entries); }
  const [open, setOpen] = useState(false);
  const r = resolveTranslation(local, i18n.language, original);
  if (!['translated', 'stale', 'pending', 'failed'].includes(r.state)) return null;

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8, marginTop: 4, minWidth: 0 }}>
      {r.state !== 'pending' && r.state !== 'failed' && (
        <span style={{ fontSize: 12, color: t.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
          {r.text}
        </span>
      )}
      <TranslationBadge dark={dark} resolved={r} onClick={() => setOpen(o => !o)} />
      {open && (
        <TranslationPopover dark={dark} original={original ?? ''} entries={local} target={target}
          onClose={() => setOpen(false)} onChange={setLocal} />
      )}
    </div>
  );
}
